var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
/**
 * TASK-084 — universal delete dialog used wherever an authority record can be
 * archived. On confirm calls {@link useDeleteRecord}; on 409 the catch path renders
 * the blocking-references panel and offers a "Use redirect instead" affordance; the caller
 * decides where it leads (since CZNA-1577 the „Zrušit s náhradou“ page in redirect mode,
 * RecordReplace — it used to be the RedirectDialog).
 *
 * <p>CZNA-580 — that affordance used to be VOCABULARY_*-only, gated by an `isVocabulary`
 * prop, with a `delete.blocked.nonVocabHint` line ("this record type cannot be redirected")
 * shown to everyone else. It was a faithful mirror of the backend's own type guard in
 * RecordReviewServiceImpl, and it stopped being true when that guard came out: PATCH
 * /records/{id}/review now accepts a redirect for any record type. The prop is gone rather
 * than defaulted, because leaving a false sentence reachable is worse than a two-line diff —
 * and the sole call site (ReviewQueue) only ever computed it from `type.startsWith`.
 *
 * <p>What still bounds the affordance is the backend's `actions`: the caller passes
 * {@code onRedirectInstead} only when the record offers `redirect` (CZNA-1531 made that legal
 * in Kontrola NK too).
 *
 * <p>CZNA-1531 (F7) — an authority record is cancelled only with a comment saying why; the
 * backend refuses it without one. A vocabulary term keeps the comment optional.
 */
import React, { useState } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { Button, Modal, ModalFooter, MessageBanner, Layout, TextArea, } from '@folio/stripes/components';
import { useDeleteRecord } from '../../hooks/useDeleteRecord';
import { getErrorInfo } from '../../utils/getErrorCode';
import { getProposalErrorMessageId } from '../../utils/getErrorMessageId';
export var DeleteWithRefsDialog = function (_a) {
    var open = _a.open, recordId = _a.recordId, recordType = _a.recordType, headingValue = _a.headingValue, onClose = _a.onClose, onDeleted = _a.onDeleted, onRedirectInstead = _a.onRedirectInstead;
    var intl = useIntl();
    var _b = useState(null), blocked = _b[0], setBlocked = _b[1];
    var _c = useState(null), errorMessageId = _c[0], setErrorMessageId = _c[1];
    var _d = useState(''), comment = _d[0], setComment = _d[1];
    var commentRequired = !(recordType === null || recordType === void 0 ? void 0 : recordType.startsWith('VOCABULARY_'));
    var _e = useDeleteRecord(recordId, {
        onSuccess: function () {
            setBlocked(null);
            setErrorMessageId(null);
            onDeleted === null || onDeleted === void 0 ? void 0 : onDeleted();
            onClose();
        },
        onBlocked: function (error) {
            setErrorMessageId(null);
            setBlocked(error.payload.blockingReferences);
        },
        onError: function (error) { return __awaiter(void 0, void 0, void 0, function () {
            var _a, _b;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        setBlocked(null);
                        _a = setErrorMessageId;
                        _b = getProposalErrorMessageId;
                        return [4 /*yield*/, getErrorInfo(error)];
                    case 1:
                        _a.apply(void 0, [_b.apply(void 0, [_c.sent()])]);
                        return [2 /*return*/];
                }
            });
        }); },
    }), mutate = _e.mutate, isLoading = _e.isLoading;
    var handleConfirm = function () {
        setBlocked(null);
        setErrorMessageId(null);
        mutate(comment.trim() || undefined);
    };
    var handleClose = function () {
        setBlocked(null);
        setErrorMessageId(null);
        setComment('');
        onClose();
    };
    var footer = blocked ? (React.createElement(ModalFooter, null,
        onRedirectInstead ? (React.createElement(Button, { buttonStyle: "primary", onClick: function () {
                setBlocked(null);
                onRedirectInstead();
            }, marginBottom0: true },
            React.createElement(FormattedMessage, { id: "ui-czna-authorities.delete.blocked.useRedirectInstead" }))) : null,
        React.createElement(Button, { onClick: handleClose, marginBottom0: true },
            React.createElement(FormattedMessage, { id: "ui-czna-authorities.delete.dialog.close" })))) : (React.createElement(ModalFooter, null,
        React.createElement(Button, { buttonStyle: "danger", onClick: handleConfirm, disabled: isLoading || (commentRequired && !comment.trim()), marginBottom0: true, "data-test-delete-confirm": true },
            React.createElement(FormattedMessage, { id: "ui-czna-authorities.delete.dialog.confirm" })),
        React.createElement(Button, { onClick: handleClose, disabled: isLoading, marginBottom0: true },
            React.createElement(FormattedMessage, { id: "ui-czna-authorities.delete.dialog.cancel" }))));
    return (React.createElement(Modal, { open: open, onClose: handleClose, label: intl.formatMessage({ id: 'ui-czna-authorities.delete.dialog.title' }), size: "medium", footer: footer, dismissible: true }, !blocked ? (React.createElement(Layout, { className: "padding-bottom-gutter" },
        errorMessageId ? (React.createElement(MessageBanner, { type: "error", "data-test-delete-error": true },
            React.createElement(FormattedMessage, { id: errorMessageId }))) : null,
        React.createElement(FormattedMessage, { id: "ui-czna-authorities.delete.dialog.message", values: { heading: headingValue, recordType: recordType } }),
        React.createElement(TextArea, { label: intl.formatMessage({
                id: commentRequired
                    ? 'ui-czna-authorities.delete.dialog.comment.required'
                    : 'ui-czna-authorities.delete.dialog.comment.optional',
            }), value: comment, required: commentRequired, maxLength: 2000, onChange: function (event) { return setComment(event.target.value); } }))) : (React.createElement(Layout, { className: "padding-bottom-gutter" },
        React.createElement(MessageBanner, { type: "warning", "data-test-blocking-refs": true },
            React.createElement(FormattedMessage, { id: "ui-czna-authorities.delete.blocked.message", values: {
                    rd: blocked.recordDataCount,
                    pd: blocked.proposalDataCount,
                } })),
        blocked.samples.length > 0 ? (React.createElement("ul", { "data-test-blocking-refs-samples": true }, blocked.samples.map(function (s, idx) {
            var _a, _b, _c;
            return (React.createElement("li", { key: "".concat(s.kind, "-").concat((_b = (_a = s.recordId) !== null && _a !== void 0 ? _a : s.proposalId) !== null && _b !== void 0 ? _b : idx, "-").concat(s.fieldTag, "-").concat(idx) },
                React.createElement("strong", null, s.kind === 'record_data' ? s.recordType : s.proposalType),
                ': ', (_c = s.headingValue) !== null && _c !== void 0 ? _c : s.proposalId,
                ' (',
                s.fieldTag,
                ")"));
        }))) : null))));
};
export default DeleteWithRefsDialog;
